//import { grey } from '@mui/material/colors';

export const darkTheme = {
    palette: {
        mode: "dark",
    },
};